module.exports = "table{width:100%;margin-bottom:20px}\n"